import { LoaderProps } from './type';
import { LoaderStyled, LoaderFrameStyled, LoaderPointStyled } from './styled';

const Loader = ({ ...props }: LoaderProps) => (
  <LoaderStyled size={props.size} data-testid="loader-id">
    <LoaderFrameStyled>
      {Array.from(Array(8).keys()).map((pointId) => (
        <LoaderPointStyled key={pointId} {...props} pointId={pointId + 1} />
      ))}
    </LoaderFrameStyled>
  </LoaderStyled>
);

Loader.defaultProps = {
  size: 16,
  pointRadio: '2px',
};

export default Loader;
